import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const distributorTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Distributor Configuration',
  key: 'distributorConfig',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['name', 'moduleName', 'instanceId'],
          ['afType', 'nodeName', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      name: {
        type: 'text',
        label: 'Configuration Name',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
          ],
        },
      },
      moduleName: {
        label: 'Module Name',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Select a module',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      instanceId: {
        label: 'Instance ID',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Select an instance ID',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      afType: {
        label: 'AF Type',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Select an AF type',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      nodeName: {
        label: 'Xcipio Node',
        type: 'select',
        options: [
          {
            label: 'Select a Node',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
    },
  },
  listeners: {
    metadata: {
      layout: {
        rows: [
          [
            'afProtocol',
            'ipAddress',
            'port',
          ],
          [
            'requiredState',
            'status',
            '$empty',
          ],
          [
            'allowedIPAddresses',
            '$empty',
            '$empty',
          ],
        ],
        collapsible: {
          label: 'Advanced Settings',
          rows: [
            [
              'keepaliveTimeout',
              'maxConcurrentConnection',
              'secInfoId',
            ],
            [
              'transport',
              'synchronizationHeader',
              'numberOfParsers',
            ],
          ],
        },
      },
    },
    fields: {
      afProtocol: {
        label: 'Listener Type',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Select a listener type',
            value: '',
          },
        ],
        optionsFirstTranslatable: true,
        validation: {
          required: true,
        },
      },
      ipAddress: {
        label: 'Listening IP Address',
        type: 'textSuggest',
        options: [],
        initial: '',
        placeholder: 'Type or select IP Address...',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
            {
              type: 'customFunction',
              customValidationFunction: 'ipPortTransportCombinationValidator',
              errorMessage: 'IP address, Transport and Port combination not unique. Please review.',
            },
          ],
        },
      },
      port: {
        label: 'Listening Port',
        type: 'text',
        initial: '1',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[1, 65535]],
              errorMessage: 'Must be between 1 - 65535. Please re-enter.',
            },
            {
              type: 'triggerValidationOnAnotherField',
              theOtherField: 'ipAddress',
            },
            {
              type: 'customFunction',
              customValidationFunction: 'ipPortTransportCombinationValidator',
            },
          ],
        },
      },
      keepaliveTimeout: {
        label: 'Keepalive Timeout (secs)',
        type: 'text',
        initial: '300',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [[0, 4096]],
              errorMessage: 'Must be between 0 - 4096. Please re-enter.',
            },
          ],
        },
      },
      maxConcurrentConnection: {
        label: 'Maximum Concurrent Connections',
        type: 'text',
        initial: '128',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 6,
            },
            {
              type: 'Interval',
              intervals: [[1, 131070]],
              errorMessage: 'Must be between 1 - 131070. Please re-enter.',
            },
          ],
        },
      },
      secInfoId: {
        label: 'TLS Profile (Security Info ID)',
        type: 'advancedSelect',
        initial: '',
        allowCreate: true,
        readOnlyIfOneOption: true,
        options: [{
          label: 'None',
          value: 'Tk9ORQ',
        }],
        optionsFirstTranslatable: true,
      },
      transport: {
        label: 'Transport',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'TCP',
            value: 'TCP',
          },
          {
            label: 'UDP',
            value: 'UDP',
          },
          {
            label: 'ZPULL',
            value: 'ZPULL',
          },
        ],
        validation: {
          validators: [
            {
              type: 'customFunction',
              customValidationFunction: 'ipPortTransportCombinationValidator',
              errorMessage: 'IP address, Transport and Port combination not unique. Please review.',
            },
          ]
        }
      },
      requiredState: {
        label: 'Configured State',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Active',
            value: 'ACTIVE',
          },
          {
            label: 'Inactive',
            value: 'INACTIVE',
          },
        ],
        optionsTranslatable: true,
      },
      status: {
        label: 'Current State',
        type: 'text',
        initial: '',
        readOnly: true,
        hide: 'false',
        renderAsEmptyIfHidden: true,
      },
      synchronizationHeader: {
        label: 'Sync Header',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: 'TPKT',
            value: 'TPKT',
          },
          {
            label: 'TPKT_W_X224',
            value: 'TPKT_W_X224',
          },
        ],
        optionsFirstTranslatable: true,
      },
      numberOfParsers: {
        label: 'Number Of Parsers',
        type: 'text',
        initial: '2',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [[1, 16]],
              errorMessage: 'Must be between 1 - 16. Please re-enter.',
            },
          ],
        },
      },
      allowedIPAddresses: {
        type: 'buttonWithMessage',
        initial: 'Allowed IP Addresses',
        className: 'allowed-ip-addresses',
      },
    },
  },
  destinations: {
    metadata: {
      layout: {
        rows: [
          [
            'ipAddress',
            'port',
            'requiredState',
          ],
          [
            'status',
            'connectionType',
            '$empty',
          ],
        ],
        collapsible: {
          label: 'Advanced Settings',
          rows: [
            [
              'keepaliveInterval',
              'keepaliveRetries',
              'numOfConnections',
            ],
            [
              'secInfoId',
              'transport',
              'protocol',
            ],
          ],
        },
      },
    },
    fields: {
      ipAddress: {
        label: 'Destination IP Address',
        type: 'text',
        placeholder: 'Type or select IP Address...',
        options: [],
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
            {
              type: 'customFunction',
              customValidationFunction: 'ipPortTransportCombinationValidator',
              errorMessage: 'IP address, Transport and Port combination not unique. Please review.',
            },
          ],
        },
      },
      port: {
        label: 'Destination Port',
        type: 'text',
        placeholder: 'Type or select IP Port...',
        options: [],
        initial: '1',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[1, 65535]],
              errorMessage: 'Must be between 1 - 65535. Please re-enter.',
            },
            {
              type: 'triggerValidationOnAnotherField',
              theOtherField: 'ipAddress',
            },
            {
              type: 'customFunction',
              customValidationFunction: 'ipPortTransportCombinationValidator',
            },
          ],
        },
      },
      keepaliveInterval: {
        label: 'Keepalive Interval (secs)',
        type: 'text',
        initial: '60',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [[1, 240]],
              errorMessage: 'Must be between 1 - 240. Please re-enter.',
            },
          ],
        },
      },
      keepaliveRetries: {
        label: 'Keepalive Retries',
        type: 'text',
        initial: '6',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [[1, 10]],
              errorMessage: 'Must be between 1 - 10. Please re-enter.',
            },
          ],
        },
      },
      numOfConnections: {
        label: 'Number of Connections',
        type: 'text',
        initial: '2',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[1, 65535]],
              errorMessage: 'Must be between 1 - 65535. Please re-enter.',
            },
          ],
        },
      },
      requiredState: {
        label: 'Configured State',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Active',
            value: 'ACTIVE',
          },
          {
            label: 'Inactive',
            value: 'INACTIVE',
          },
        ],
        optionsTranslatable: true,
      },
      status: {
        label: 'Current State',
        type: 'text',
        initial: '',
        readOnly: true,
        hide: 'false',
        renderAsEmptyIfHidden: true,
      },
      secInfoId: {
        label: 'TLS Profile (Security Info ID)',
        type: 'advancedSelect',
        initial: '',
        allowCreate: true,
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'None',
            value: 'Tk9ORQ',
          },
        ],
        optionsFirstTranslatable: true,
      },
      transport: {
        label: 'Transport',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'TCP',
            value: 'TCP',
          },
          {
            label: 'ZPUSH',
            value: 'ZPUSH',
          },
        ],
      },
      protocol: {
        label: 'Destination Protocol',
        type: 'select',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'Passthrough',
            value: 'PASSTHRU',
          },
          {
            label: 'Passthrough with SX3 header',
            value: 'PASSTHRU_W_SX3HDR',
          },
          {
            label: 'Payload Passthrough',
            value: 'PLPASSTHRU',
          },
          {
            label: 'Payload Passthrough with SX3 header',
            value: 'PLPASSTHRU_W_SX3HDR',
          },
        ],
        optionsTranslatable: true,
      },
      connectionType: {
        label: 'Connection Type',
        type: 'select',
        initial: 'PRIMARY',
        readOnlyIfOneOption: true,
        options: [
          {
            label: 'PRIMARY',
            value: 'PRIMARY',
          },
          {
            label: 'FAILOVER',
            value: 'FAILOVER',
          },
          {
            label: 'FAILOVER2',
            value: 'FAILOVER2',
          },
          {
            label: 'FAILOVER3',
            value: 'FAILOVER3',
          },
        ],
      }
    },
  },
};
